<template>
  <div class="shipment-tag-wrapper shipment-tag-azulcargo">
    <div class="shipment-tag-header">
      <div class="shipment-tag-header-left">
        <img :src="shippingCompanyIcon" class="in-center">
      </div>
      <div class="shipment-tag-header-center">
        <canvas class="melhor-ponto-code in-center"></canvas>
      </div>
      <div class="shipment-tag-header-right">
        <img :src="$parent.tag.companyIcon" class="in-center">
      </div>
    </div>

    <div>
      <div class="shipment-tag-website">
        {{ $parent.tag.website }}
      </div>
    </div>

    <div class="shipment-tag-info">
      <div class="field left">
        <span v-if="$parent.tag.invoice.number" style="text-align: left; font-size: 8pt;">NF: {{ $parent.tag.invoice.number }}</span>
        <span v-show="$parent.tag.tracking && $parent.tag.protocol" style="font-size: 8pt; text-align: initial;">{{ $parent.tag.protocol }}</span>
        <span ><strong style="font-size: 8pt;">Azul Cargo Express: * NÃO COBRAR COLETA</strong></span>
      </div>
      <div class="field right">
        <span v-if="$parent.tag.volumeIndex+1">Volume: <strong>{{$parent.tag.volumeIndex+1}}/{{$parent.tag.volumeTotal}}</strong></span>
        <span v-if="$parent.tag.package.weight">Peso (g): <strong>{{ kilogramsToGrams($parent.tag.package.weight) }}</strong></span>
      </div>
    </div>

    <p
      class="text-subtitle font-normal text-center"
      :class="{'text-with-nf': $parent.tag.invoice.number}"
    >
      {{ $parent.tag.tracking || 'MELHOR ENVIO' }}
    </p>

    <canvas class="barcode"
      :data-value="$parent.tag.tracking.replace(/[^0-9\.]+/g, '') || 'MELHOR ENVIO'"
      data-height="50"
      data-margin="0"
      data-displayvalue="false">
    </canvas>

    <div class="shipment-tag-client shipment-tag-to">
      <h2 class="text-left">DESTINATÁRIO</h2>
      <p class="line">
        {{ $parent.tag.to.name }}<template v-if="$parent.tag.to.phone.length">, TEL: {{ maskPhone($parent.tag.to.phone) }}</template>
      </p>
      <p class="line">
        {{ $parent.tag.to.address }}<template v-if="$parent.tag.to.locationNumber.length">, </template>
        {{ $parent.tag.to.locationNumber }}
      </p>
      <p class="line">
        {{ $parent.tag.to.complement }}<template v-if="$parent.tag.to.complement.length">, </template>
        {{ $parent.tag.to.district }}
      </p>
      <p class="line">
        <strong>{{ beautifyPostalCode($parent.tag.to.postalCode) }}</strong> {{ $parent.tag.to.city }}<template v-if="$parent.tag.to.stateAbbr.length">/</template>{{ $parent.tag.to.stateAbbr }}
      </p>
      <p class="line">
        <span v-show="$parent.tag.to.note.length">OBS: {{ $parent.tag.to.note }}</span>
      </p>
      <p class="line">
        <strong class="small-line">POSTAR EM: </strong>
        <strong class="small-line" v-show="$parent.tag.agency">{{ $parent.tag.agency }} {{ $parent.tag.agencyCity }}</strong>
        <strong class="small-line" v-show="!$parent.tag.agency">AGÊNCIA NÃO SELECIONADA</strong>
      </p>
      <div class="shipment-tag-optionals">
        <span v-show="$parent.tag.receipt">AR</span>
      </div>
    </div>

    <div class="shipment-tag-client">
      <h2 class="text-left">REMETENTE</h2>
      <p class="line">
        {{ $parent.tag.from.name }}<template v-if="$parent.tag.from.phone.length">, TEL: {{ maskPhone($parent.tag.from.phone) }}</template>
      </p>
      <p class="line">
        {{ $parent.tag.from.address }}<template v-if="$parent.tag.from.locationNumber.length">, </template>
        {{ $parent.tag.from.locationNumber }}
      </p>
      <p class="line">
        {{ $parent.tag.from.complement }}<template v-if="$parent.tag.from.complement.length">, </template>
        {{ $parent.tag.from.district }}
      </p>
      <p class="line">
        <strong>{{ beautifyPostalCode($parent.tag.from.postalCode) }}</strong> {{ $parent.tag.from.city }}<template v-if="$parent.tag.from.stateAbbr.length">/</template>{{ $parent.tag.from.stateAbbr }}
      </p>
    </div>
  </div>
</template>

<script>
  import { kilogramsToGrams, maskPhone } from 'commons/js/formatters/Mask';
  import { beautifyPostalCode } from 'commons/js/formatters/PostalCode';
  import MelhorPontoQrCode from 'commons/js/mixins/melhorPontoQrCode';

  export default {
    mixins: [MelhorPontoQrCode],

    data() {
      return {
        shippingCompanyIcon: ''
      }
    },

    mounted() {
      BarCode('.barcode').init();

      this.shippingCompanyIcon = '/images/shipping-companies/azulcargopb.png';
    },

    methods: {
      kilogramsToGrams,
      maskPhone,
      beautifyPostalCode
    }
  }
</script>

<style lang="stylus" scoped>
.shipment-tag-azulcargo
  .text-left
    text-align left
  strong
    font-weight bold
  .shipment-tag-header
    padding 5px
    height 110px
    .in-center
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%) scale(1.1)
    img
      width 90%
    .shipment-tag-header-left
    .shipment-tag-header-center
    .shipment-tag-header-right
      position relative
      width 33.33%
      height 100%
      display inline-block
    .shipment-tag-header-left
      float left
    .shipment-tag-header-center
      margin 0 auto
    .shipment-tag-header-right
      float right
  .small-line
    font-size 8pt
  .special-infos
    padding 0 5px
  .shipment-tag-info
    >>> .field
      text-align center
      margin-top -15px
      font-weight bold
      line-height 1
      &.left
        float left
        margin-left 10px
      &.right
        float right
        margin-right 6px
      span
        height 12px
        display block
  .shipment-tag-website
    font-size 7pt !important
    width 33.33%
    float right
    text-align center
    margin-top -30px
    font-weight bold
  .shipment-tag-client
    margin 5px
    padding 0 5px
    position relative
    h2
      margin 5px 0
      font-weight bold
    p
      margin 0
      white-space nowrap
      text-transform uppercase
    &.shipment-tag-to
      border 1px solid #9c9c9c
      border-radius 3px
      .line
        padding-right 10px
  .shipment-tag-optionals
    position absolute
    top 5px
    right 5px
    font-weight bold
    line-height 1.1
    span
      width 45px
      text-align center
      font-size 16pt
      border 1px solid #000
      padding 5px
      margin-bottom 5px
      display block

@media print
  .shipment-tag-azulcargo
    .shipment-tag-header
      height 110px !important
    img
      width 85%
    .shipment-tag-website
      display block
</style>
